import OwlCarousel from 'react-owl-carousel';
export default function TestimonialThree(){
    return(
        <>
        <section className="testimonial-area testimonial-area2 nav-style-1 pt-120 pb-60 pt-md-60 pt-xs-60">
			<div className="container">
				<div className="row">
					<div className="col-lg-6">
						<div className="core-feature-title text-md-start">
							<p className="lh-1 mb-10">User Feedbacks</p>
							<h2 className="sect-title text-heding3">1000+ Active Reviews</h2>
						</div>
					</div>
				</div>
			</div>
			<div className="custom-container-1">
				
                <OwlCarousel items={3}  
			className="owl-theme testimonial-slide2"  
			loop 
			dots={false}
			nav={true}
            center={true}			  
			margin={30} >
					<div className="item">
						<div className="testimonial-text-wrapper2">
							<div className="rating mb-10">
								<a href="#"><i className="fas fa-star"></i></a>
								<a href="#"><i className="fas fa-star"></i></a>
								<a href="#"><i className="fas fa-star"></i></a>
								<a href="#"><i className="fas fa-star"></i></a>
								<a href="#"><i className="fas fa-star"></i></a>
							</div>
							<h5 className="fs-20">“ Professional & modern, a theme designed
								to help your business stand out from the rest.
								For marketing firms. ”</h5>
							<div className="author-box">
								<img className="author-img" src="assets/img/testimonial/t-2a.jpg" alt="Image" />
								<div className="author-content">
									<h6>Alonso W. William</h6>
									<p>-Head Of Idea</p>
								</div>
							</div>
							<div className="quote-icon">
								<img src="assets/img/testimonial/quorte-1.png" alt="Icon" />
							</div>
						</div>
					</div>
					<div className="item">
						<div className="testimonial-text-wrapper2">
							<div className="rating mb-10">
								<a href="#"><i className="fas fa-star"></i></a>
								<a href="#"><i className="fas fa-star"></i></a>
								<a href="#"><i className="fas fa-star"></i></a>
								<a href="#"><i className="fas fa-star"></i></a>
								<a href="#"><i className="fas fa-star"></i></a>
							</div>
							<h5 className="fs-20">“ Professional & modern, a theme designed
								to help your business stand out from the rest.
								For marketing firms. ”</h5>
							<div className="author-box">
								<img src="assets/img/testimonial/t-2a.jpg"  className="author-img" alt="Image" />
								<div className="author-content">
									<h6>Alonso W. William</h6>
									<p>-Head Of Idea</p>
								</div>
							</div>
							<div className="quote-icon">
								<img src="assets/img/testimonial/quorte-1.png" alt="Icon" />
							</div>
						</div>
					</div>
					<div className="item">
						<div className="testimonial-text-wrapper2">
							<div className="rating mb-10">
								<a href="#"><i className="fas fa-star"></i></a>
								<a href="#"><i className="fas fa-star"></i></a>
								<a href="#"><i className="fas fa-star"></i></a>
								<a href="#"><i className="fas fa-star"></i></a>
								<a href="#"><i className="fas fa-star"></i></a>
							</div>
							<h5 className="fs-20">“ Professional & modern, a theme designed
								to help your business stand out from the rest.
								For marketing firms. ”</h5>
							<div className="author-box">
								<img className="author-img" src="assets/img/testimonial/t-2a.jpg" alt="Image" />
								<div className="author-content">
									<h6>Alonso W. William</h6>
									<p>-Head Of Idea</p>
								</div>
							</div>
							<div className="quote-icon">
								<img src="assets/img/testimonial/quorte-1.png" alt="Icon" />
							</div>
						</div>
					</div>
					<div className="item">
						<div className="testimonial-text-wrapper2">
							<div className="rating mb-10">
								<a href="#"><i className="fas fa-star"></i></a>
								<a href="#"><i className="fas fa-star"></i></a>
								<a href="#"><i className="fas fa-star"></i></a>
								<a href="#"><i className="fas fa-star"></i></a>
								<a href="#"><i className="fas fa-star"></i></a>
							</div>
							<h5 className="fs-20">“ Professional & modern, a theme designed
								to help your business stand out from the rest.
								For marketing firms. ”</h5>
							<div className="author-box">
								<img className="author-img" src="assets/img/testimonial/t-2a.jpg" alt="Image" />
								<div className="author-content">
									<h6>Alonso W. William</h6>
									<p>-Head Of Idea</p>
								</div>
							</div>
							<div className="quote-icon">
								<img src="assets/img/testimonial/quorte-1.png" alt="Icon" />
							</div>
						</div>
					</div>
                    </OwlCarousel>
				
			</div>
		</section>
        </>
    )
}